// ============================================================================
// ThemeMetaSync — Keeps document.title & meta description in sync with theme
// ============================================================================
import { useEffect } from "react";
import { pwa } from "../../config/theme";

export function ThemeMetaSync() {
  useEffect(() => {
    document.title = pwa.name;

    const metaDescription = document.querySelector<HTMLMetaElement>(
      'meta[name="description"]',
    );
    if (metaDescription) {
      metaDescription.content = pwa.description;
    }

    const metaThemeColor = document.querySelector<HTMLMetaElement>(
      'meta[name="theme-color"]',
    );
    if (metaThemeColor) {
      metaThemeColor.content = pwa.themeColor;
    }
  }, []);

  return null;
}
